module.exports = __webpack_public_path__ + "img/friaxAzul.919a6d51.svg";